import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mq_List } from '../mq_list/mq_list';
import { MSteps } from '../msteps/msteps';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { ClockComponent } from '../component/clock';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mj_statistiche',
  templateUrl: 'mj_statistiche.html', 
})
export class Mj_Statistiche extends Util {
  pagine: any;
  user: any;
  mj: any;
  fasi: any;
  items: any = [];
  //itemExpandHeight = 150;
  itemExpandHeight = [];
  mqs: any = [];
  statistiche:any = {grafici:[],lista:[]};
  @ViewChild('polarid') polarid: ElementRef;
  @ViewChild('content') private content: any;
  language = 'it';
  constructor(public navCtrl: NavController,public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController,clock: ClockComponent,public theme: EthemeProvider) {
    super(injector, loading); 
    this.user = this.navParams.get('user');
    this.mj = this.navParams.get('mj');
    //console.log('---mj:',this.mj);
    this.refreshpage(this.mj);

  }
  ngOnInit(): void {
    //console.log(this.navCtrl.getViews());
    this.language = this.translate.getDefaultLang();
  }
  refreshpage(mj) {
    this.GetRequest('statisticheMJ', mj.id).then(data => {
      //console.log(data);
      this.statistiche = data;

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }

  open_quest(m) {
    this.navCtrl.push(Mq_List, { mq_list: m });
  }
  // open_fase(m, i) {

  //   if(m.stato == 'IN_ATTESA'){
  //     this.showBasicAlert('Fase in Attesa','Non puoi accedere a questa fase');
  //     return;
  //   }

  //   this.GetRequest('microQuestFase', m.id,false,false).then(data => {

  //     //this.mqs = data['MicroQuestList'];

  //     this.fasi.map((listItem, index) => {

  //       if (m == listItem) {
  //         listItem.expanded = !listItem.expanded;
  //         this.mqs[index] = data['MicroQuestList'];
  //         // //console.log(50 * data['MicroQuestList'].length+1);
  //         this.itemExpandHeight[i] = 150 * data['MicroQuestList'].length+1;
  //       } else {
  //         listItem.expanded = false;
  //       }

  //       return listItem;

  //     });

  //   }).catch((e) => {
  //     console.error(e)
  //   })
  // }

  expandItem(item) {

    this.items.map((listItem) => {

      if (item == listItem) {
        listItem.expanded = !listItem.expanded;
      } else {
        listItem.expanded = false;
      }

      return listItem;

    });

  }
  // open_questionario(m,h) {
  //   if(m.attivo == false)
  //   {
  //     this.showBasicAlert('Alert','Questionario non attivo');
  //     return;
  //   }
  //   this.presentPopover(event, Confirm, 'Sei sicuro di voler iniziare ?',h+1).then((data) => {
  //     //console.log(data);
  //     if (data == 'confirm')
  //       this.navCtrl.push(MSteps, { mq: m ,mj:this.mj});
  //   });

  // }
  back(){
    this.navCtrl.pop({animate:false});
  }
  go_root(){
    this.navCtrl.setRoot(Dashboard);
  }
  polargrafico =  null;
  open_grafico(graficoid,indice){
    this.GetRequest('dettagli_grafico/'+this.mj.id+'/'+graficoid, indice).then(data => {
      // console.log(data);
      this.polargrafico = data;
      //this.statistiche = data;
      setTimeout(() => {
        // console.log(this.polarid.nativeElement.offsetTop);
        // window.scrollTo(0, this.polarid.nativeElement.offsetTop);  
        // this.content.scrollToBottom(this.polarid.nativeElement.offsetTop- 300);
        this.content.scrollTo(0,this.polarid.nativeElement.offsetTop,200);
      }, 200);
      
    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/mj_statistiche/mj_statistiche.ts